module.exports = __webpack_public_path__ + "img/expand_icon.da3bcca5.svg";